import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum ServiceWaitingListUnitEnum {
    UNITS_1_2 = 'units1_2',
    UNITS_1_3 = 'units1_3',
    UNITS_1_5 = 'units1_5',
    UNITS_1_10 = 'units1_10',
    UNITS_1_3_5 = 'units1_3_5',
}

export const serviceWaitingListUnitEnumOptions = enumToOptions(ServiceWaitingListUnitEnum, 'service.settings.general.waitingList.units.');

export const serviceWaitingListUnitEnumValues = {
    [ServiceWaitingListUnitEnum.UNITS_1_2]: [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
    ],
    [ServiceWaitingListUnitEnum.UNITS_1_3]: [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
    ],
    [ServiceWaitingListUnitEnum.UNITS_1_5]: [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
    ],
    [ServiceWaitingListUnitEnum.UNITS_1_10]: [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 },
        { name: '7', value: 7 },
        { name: '8', value: 8 },
        { name: '9', value: 9 },
        { name: '10', value: 10 },
    ],
    [ServiceWaitingListUnitEnum.UNITS_1_3_5]: [
        { name: '1', value: 1 },
        { name: '3', value: 3 },
        { name: '5', value: 5 }],
};
